import React from 'react'

const Module = ({ item, form }) => {
  const Component = item.module
  return (
    <div className={item?.className ? item?.className : ''}>
      <Component
        change={form.change}
        data={form.data}
        submit={form.submit}
        validation={form.validation}
        bound={form.bound}
        item={item}
        bind={form.bind}
        defaultValues={form.defaultValues}
        valid={form.valid}
      />
    </div>
  )
}

// Return Input in view

export default Module
